import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import { PulseAdapter } from '@/adapters';
import type {
  PulseCategory,
  SOPGenerateJob,
  PulseSubcategoryCountsResponseDto,
  SOPGenerateResponseDto,
  SOPJobStatusResponseDto
} from '@/types';

export const pulseService = {
  async getSubcategoryCounts(
    params?: { startDate?: string; endDate?: string; bu_id?: string },
  ): Promise<PulseCategory[]> {
    const response = await api.get<PulseSubcategoryCountsResponseDto>(API_ENDPOINTS.PULSE.SUBCATEGORY_COUNTS, { params });
    return PulseAdapter.fromSubcategoryCountsApi(response.data);
  },

  async generateSOP(
    sopCatId: string,
    startDate?: string,
    endDate?: string,
    integrations: string[] = []
  ): Promise<{ jobId: string }> {
    const response = await api.post<SOPGenerateResponseDto>(API_ENDPOINTS.PULSE.GENERATE_SOP(sopCatId), {
      startDate,
      endDate,
      integrations
    });
    return response.data.data;
  },

  async getJobStatus(jobId: string): Promise<SOPGenerateJob> {
    const response = await api.get<SOPJobStatusResponseDto>(API_ENDPOINTS.PULSE.JOB_STATUS(jobId));
    return PulseAdapter.fromJobStatusApi(response.data);
  }
};
